import { ResponseData, Err } from 'types';

import { http } from '.';

export const addBankAccount = async (payload) => {
  return await http.post<Err, ResponseData<1>>(`/BankDatas`, payload);
};

export const updateBankAccount = async (payload) => {
  return await http.put<Err, ResponseData<1>>(`BankDatas`, payload);
};

export const getBanks = async () => {
  return await http.get<Err, ResponseData<any>>(
    `/BankDatas/GetMyBankShortDatas`
  );
};

export const getBankById = async (id: number) => {
  return await http.get<Err, ResponseData<any>>(
    `/BankDatas/GetBankDataById?bankId=${id}`
  );
};

export const deleteBank = async (id: number) => {
  return await http.delete<Err, ResponseData<boolean>>(`BankDatas/${id}`);
};
